import { render, staticRenderFns } from "./ApproveExits.vue?vue&type=template&id=2cc23bcf"
import script from "./ApproveExits.vue?vue&type=script&lang=js"
export * from "./ApproveExits.vue?vue&type=script&lang=js"
import style0 from "./ApproveExits.vue?vue&type=style&index=0&id=2cc23bcf&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports